import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            韩国漫画常见问题
          </h2>
          <p className="text-foreground-500 text-sm">
            关于<strong>韩国漫画</strong>，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h4 className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400">
                  <i
                    className={`text-lg transition-transform duration-300 ${
                      openIdx === idx ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}